<div class="label-container">
    <span matSnackBarLabel>
    {{ message }}
</span>

<span matSnackBarActions>
    <button mat-flat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
        {{ 'toast.error-action' | translate }}
    </button>
</span>
</div>

<mat-expansion-panel>
    <mat-expansion-panel-header>
        <mat-panel-title>
            {{ 'toast.error-details' | translate }}
        </mat-panel-title>
        <mat-panel-description>
            {{ 'toast.click-to-expand-action' | translate }}
        </mat-panel-description>
    </mat-expansion-panel-header>
    <p class="mt-20">Status: {{ data.problemDetail.status }}</p>
    <p *ngIf="data.problemDetail.title" class="wrap-word">{{ data.problemDetail.title }}</p>
    <p *ngIf="data.problemDetail.detail" class="wrap-word">{{ data.problemDetail.detail }}</p>
</mat-expansion-panel>

<app-pre *ngIf="0" [obj]="data" />